import React, { useState } from 'react'
import toast from 'react-hot-toast'
import { Eye, LogOut } from 'lucide-react'
import { useAuth } from '../context/AppContext'

// Renders only while AppContext's `impersonation` state is active - and that
// state is re-derived from /auth/me on load, on a poll, and on any 403, so
// this banner never trusts a click as the source of truth for "am I still
// impersonating" (see AppContext.jsx's SCOPE_MISMATCH_EVENT wiring).
export default function ImpersonationBanner() {
  const { impersonation, endImpersonationSession } = useAuth()
  const [ending, setEnding] = useState(false)

  if (!impersonation?.active) return null

  const handleEnd = async () => {
    setEnding(true)
    try {
      await endImpersonationSession()
      toast.success('Impersonation ended.')
    } catch {
      toast.error('Failed to end impersonation session.')
    } finally {
      setEnding(false)
    }
  }

  return (
    <div
      role="status"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        // Its own row, never squeezed: .main-area is a flex column, and
        // without this the banner can shrink under the scrolling content
        // and sit on top of the page header (the partner dashboard's
        // range picker was where it showed).
        flexShrink: 0,
        flexWrap: 'wrap',
        position: 'relative',
        zIndex: 40,
        gap: 12,
        padding: '10px 20px',
        background: 'var(--amber-bg)',
        borderBottom: '1px solid var(--amber)',
        color: 'var(--amber)',
        fontSize: 13,
        fontWeight: 600,
      }}
    >
      <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <Eye size={15} />
        Viewing as {impersonation.company_name}
      </span>
      <button
        type="button"
        className="btn btn-ghost btn-sm"
        onClick={handleEnd}
        disabled={ending}
        style={{ color: 'inherit', border: '1px solid currentColor' }}
      >
        <LogOut size={13} style={{ marginRight: 6 }} />
        {ending ? 'Ending...' : 'End session'}
      </button>
    </div>
  )
}
